// extracted by mini-css-extract-plugin
module.exports = {"group-container":"Group_group-container__1zRJM","group-information-container":"Group_group-information-container__3P-u5"};